/**
 * If the API returned a full Quill-style document (e.g. wrapped in `.ql-editor`),
 * return only the inner HTML meant for storage/editing.
 * @param {unknown} html
 * @returns {string}
 */
export function normalizeStoredRichHtml(html) {
  const raw = String(html ?? "").trim();
  if (!raw) return "";
  if (!raw.includes("ql-editor")) return raw;
  try {
    const doc = new DOMParser().parseFromString(raw, "text/html");
    const ed = doc.querySelector(".ql-editor");
    if (ed) return ed.innerHTML.trim();
  } catch {
    /* ignore */
  }
  return raw;
}
